(function () {
  'use strict';

  angular.module('eclipseApp.bts')
    .config(['$stateProvider', function ($stateProvider) {
      $stateProvider
        .state('btsOffer', {
          url: '/bts-offers',
          parent: 'app',
          title : "btsOffers",
          data: {
            service: 'btsPromotion'
          },
          views: {
            content: {
              templateUrl: 'modules/bts-offers/views/btsOffer.html',
              controller: 'btsOffersCtrl'
            }
          },
          onEnter:  ['env',function (env) {
            // Goto specific url DSO-2166
            window.location.href = env.fidoHomePageUrl;
          }]
        });
    }]);

})();
